// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import ApexCharts from "apexcharts"

// Inline <script> tags in views are non-module scripts and can only reach
// these through the global scope.
window.bootstrap = bootstrap
window.ApexCharts = ApexCharts

// Tabler drives every chart colour from its CSS custom properties rather than
// from literal hexes, so a theme change flows through to the charts. This is
// the same accessor Tabler's own demo uses as `tabler.getColor`.
window.tablerColor = function (name, opacity) {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(`--tblr-${name}`)
    .trim()
  if (!value) return name
  if (opacity === undefined) return value

  const rgb = getComputedStyle(document.documentElement)
    .getPropertyValue(`--tblr-${name}-rgb`)
    .trim()
  return rgb ? `rgba(${rgb}, ${opacity})` : value
}

// Charts rendered on a page are torn down before Turbo swaps <body>. Without
// this they keep their listeners and ResizeObservers and leak across visits.
const charts = new Set()

window.registerChart = function (chart) {
  charts.add(chart)
  return chart
}

document.addEventListener("turbo:before-render", () => {
  charts.forEach((chart) => {
    try { chart.destroy() } catch (e) { /* already gone */ }
  })
  charts.clear()
})
